export enum EnaioVariantInsertType {
    asChild = 0,
    asSibling = 1,
    asMain = 2
}
export namespace EnaioVariantInsertType{
    export function getName(value: EnaioVariantInsertType): string {
        switch (value) {
            case EnaioVariantInsertType.asChild:
                return "asChild";
            case EnaioVariantInsertType.asSibling:
                return "asSibling";
            case EnaioVariantInsertType.asMain:
                return "asMain";
        }
    }
}
